'use es6';

import { isEmpty } from 'underscore';
import { OrderedMap } from 'immutable';
import getIdentifier from 'forms-utils-lib/formField/utils/getIdentifier';
const getAllFieldsFromForm = (groups = []) => {
  const results = groups.reduce((accum, group) => {
    group.fields.forEach(field => {
      field.dependentFieldFilters.forEach(({
        dependentFormField
      }) => {
        if (!isEmpty(dependentFormField)) {
          accum = [...accum, [getIdentifier(dependentFormField), {
            field: dependentFormField,
            isDependent: true,
            group
          }]];
        }
      });
      accum = [...accum, [getIdentifier(field), {
        field,
        isDependent: false,
        group
      }]];
    });
    return accum;
  }, []);
  return new OrderedMap(results);
};
export default getAllFieldsFromForm;